export default __webpack_public_path__ + "7c345955b18afb03842fa4424c040419.svg";